import React from 'react';
import { TripSummaryCard } from '@pcln/cards';
import getMediaNode from '../helpers/getMediaNode';
import TripDates, { getDates } from '../helpers/TripDates';
const RC_START_DATE_LABEL = 'Pick-up';
const RC_END_DATE_LABEL = 'Drop-off';
/** @public */
const UpcomingRentalCar = ({
  imageUrl,
  rcBrandLogoUrl,
  rentalCarName,
  destination,
  travelStartDate,
  travelEndDate,
  truncateHeading,
  showArrowRight,
  onClick,
  handleSubmitCTA,
  actionText,
  buttonNode
}) => {
  const [startDate, endDate] = getDates(travelStartDate, travelEndDate);
  return React.createElement(TripSummaryCard, {
    mediaNode: getMediaNode('DRIVE', imageUrl, rcBrandLogoUrl),
    mediaNodeBackgroundColor: imageUrl ? 'transparent' : 'primary.light',
    heading: rentalCarName,
    caption: destination,
    noTranslateCaption: true,
    body: React.createElement(TripDates, {
      startDateLabel: RC_START_DATE_LABEL,
      endDateLabel: RC_END_DATE_LABEL,
      startDate: startDate,
      endDate: endDate
    }),
    truncateHeading: truncateHeading,
    showArrowRight: showArrowRight,
    onClick: onClick,
    handleSubmitCTA: handleSubmitCTA,
    actionText: actionText,
    buttonNode: buttonNode
  });
};
export default UpcomingRentalCar;